export const START_DRAG_WINDOW = "START_DRAG_WINDOW";
export const END_DRAG_WINDOW = "END_DRAG_WINDOW";
export const SET_WINDOW_POSITION = "SET_WINDOW_POSITION";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-drag/src/actions/actionTypes.js